import { ComponentType, FunctionComponent, ReactElement } from 'react'
import MuiTooltip, { tooltipClasses } from '@mui/material/Tooltip'
import Zoom from '@mui/material/Zoom'
import { TransitionProps } from '@mui/material/transitions'

const DARK_BG = '#0d0d0dc0'
const DEFAULT_BG = '#004b7a'

const resolveBackgroundColor = (bgColor?: string): string => {
  if (bgColor === 'dark') return DARK_BG
  return bgColor !== undefined && bgColor !== '' ? bgColor : DEFAULT_BG
}

const TealToolTip: FunctionComponent<TealToolTipProps> =
  ({
    children, title, enterDelay = 800, arrow = true,
    placement = 'bottom', TransitionComponent = Zoom, bgColor, textColor, ...props
  }) => {
    const resolvedBgColor = resolveBackgroundColor(bgColor)
    return (
      <MuiTooltip
        {...{ title, enterDelay, arrow, placement, TransitionComponent }}
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: resolvedBgColor,
              color: textColor !== undefined && textColor !== '' ? textColor : 'white',
              fontSize: '0.875rem',
              [`& .${tooltipClasses.arrow}`]: {
                color: resolvedBgColor,
                fontSize: '0.5rem',
                '&::before': { color: resolvedBgColor }
              }
            }
          }
        }}
        {...props}
      >
        {children}
      </MuiTooltip>
    )
  }

interface TealToolTipProps {
  children: ReactElement
  title: string
  leaveDelay?: number
  enterDelay?: number
  arrow?: boolean
  placement?: 'bottom' | 'left' | 'right' | 'top' | 'bottom-end' | 'bottom-start' | 'left-end' | 'left-start' | 'right-end' | 'right-start' | 'top-end' | 'top-start'
  open?: boolean
  TransitionComponent?: ComponentType<TransitionProps>
  bgColor?: string
  textColor?: string
  classes?: Record<string, string>
}

export default TealToolTip
